import { store } from '../redux/store';
import { openCheckout } from '../redux/checkout/action';
import { ICheckoutItem, IFreeTicket, IPaidTicket } from '../redux/checkout/types';
import { ISaleObject } from '../types/global/helper';
import { showToastMessage } from './AppUtils';

/**
 * Opens the checkout modal with the provided items
 * @param items Array of items to add to the checkout
 */
export const openCheckoutWithItems = (items: ICheckoutItem[], saleObject: ISaleObject) => {
    store.dispatch(openCheckout({ items, saleObject }));
};

/**
 * Utility function to open the checkout for ticket purchases
 * @param event The event details
 * @param tickets Array of ticket types with prices
 * @param currencyInfo Currency information
 */
export const purchaseEventTickets = (
    event: { id: string; title: string; image?: string },
    tickets: IPaidTicket[] | IFreeTicket[],
    saleObject: ISaleObject,
    currencyInfo?: {
        transaction_currency: string;
        original_currency?: string;
        processing_currency?: string;
        rate?: number;
    },
) => {
    // Get the transaction currency or default to USD
    const transactionCurrency = currencyInfo?.transaction_currency || 'usd';

    const items = tickets.map(ticket => ({
        id: ticket.id,
        tierId: ticket.tierId,
        title: ticket.name,
        description: ticket.description,
        original_price: ticket.original_price,
        price: ticket.price,
        currency: transactionCurrency, // Ensure currency is set for each item
        quantity: ticket.quantity,
        image: event.image,
        details: [
            { label: 'Event', value: event.title },
            { label: 'Ticket Type', value: ticket.name },
        ],
    }));

    if (!currencyInfo) {
        showToastMessage('currency information missing', 'error');
        return;
    }

    // Dispatch to open checkout with the items and set currency
    store.dispatch(
        openCheckout({
            items,
            currency: transactionCurrency,
            saleObject,
            currencyInfo: currencyInfo,
        }),
    );
};
